<template>
  <div class="password-container">
    <h2>Change Password</h2>

    <div class="cabinet-password">
      <input :type="typeCurrentPassword" placeholder="Current password" v-model="currentPassword">
      <div class="eye-indicator" :class="{'eye-indicator-closed': !showCurrentPassword}"
           @click="toggleShowCurrentPassword"></div>
    </div>

    <div class="cabinet-password">
      <input :type="typeNewPassword" placeholder="New password" v-model="newPassword">
      <div class="eye-indicator" :class="{'eye-indicator-closed': !showNewPassword}"
           @click="toggleShowNewPassword"></div>
    </div>

    <div class="cabinet-password">
      <input :type="typeRepeatPassword" placeholder="Repeat password" v-model="repeatPassword">
      <div class="eye-indicator" :class="{'eye-indicator-closed': !showRepeatPassword}"
           @click="toggleShowRepeatPassword"></div>
    </div>

    <button class="red-button" @click="change">Change</button>

    <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="cabinet-modal">
      <h3 slot="header">Login</h3>
      <p slot="body">{{ dialogMessage }}</p>
      <button slot="footer" @click="showDialog = false">OK</button>
    </Modal>
  </div>
</template>

<script>
import {Auth} from 'aws-amplify';

import Modal from "@/components/Modal";

export default {
  name: "Password",
  components: {
    Modal
  },
  data() {
    return {
      dialogMessage: false,
      showDialog: false,
      currentPassword: null,
      newPassword: null,
      repeatPassword: null,
      typeCurrentPassword: 'password',
      typeNewPassword: 'password',
      typeRepeatPassword: 'password',
      showCurrentPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
      authUser: null
    };
  },
  created() {
    window.addEventListener('keydown', this.reset);

    this.authUser = this.$store.state.authUser;
    console.log(this.authUser);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.reset);
  },
  methods: {
    toggleShowCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
      if (this.showCurrentPassword)
        this.typeCurrentPassword = 'text';
      else
        this.typeCurrentPassword = 'password';
    },
    toggleShowNewPassword() {
      this.showNewPassword = !this.showNewPassword;
      if (this.showNewPassword)
        this.typeNewPassword = 'text';
      else
        this.typeNewPassword = 'password';
    },
    toggleShowRepeatPassword() {
      this.showRepeatPassword = !this.showRepeatPassword;
      if (this.showRepeatPassword)
        this.typeRepeatPassword = 'text';
      else
        this.typeRepeatPassword = 'password';
    },
    change() {
      console.log('change!');

      if (this.currentPassword == null || this.currentPassword.length === 0) {
        this.dialogMessage = "Please type the current password";
        this.showDialog = true;
        this.reset({key: 'Escape'});
        return;
      }

      if (this.newPassword == null || this.newPassword.length === 0) {
        this.dialogMessage = "Please specify a new password";
        this.showDialog = true;
        this.reset({key: 'Escape'});
        return;
      }

      if (this.repeatPassword == null || this.repeatPassword.length === 0) {
        this.dialogMessage = "Please confirm the new password";
        this.showDialog = true;
        this.reset({key: 'Escape'});
        return;
      }

      if (this.newPassword !== this.repeatPassword) {
        this.dialogMessage = "New/confirm passwords don't match";
        this.showDialog = true;
        this.reset({key: 'Escape'});
        return;
      }

      Auth.changePassword(this.authUser, this.currentPassword, this.newPassword).then((result) => {
        console.log(result);
        this.dialogMessage = "Success!";
        this.showDialog = true;
        this.reset({key: 'Escape'})
      }).catch((error) => {
        console.log(error);
        this.dialogMessage = error.message;
        this.showDialog = true;
        this.reset({key: 'Escape'})
      });
    },
    reset(e) {
      if (e.key === 'Escape') {
        this.currentPassword = null;
        this.newPassword = null;
        this.repeatPassword = null;
        this.typeCurrentPassword = 'password';
        this.typeNewPassword = 'password';
        this.typeRepeatPassword = 'password';
        this.showCurrentPassword = false;
        this.showNewPassword = false;
        this.showRepeatPassword = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
